import { render, staticRenderFns } from "./RegistryRequestDetail.vue?vue&type=template&id=2bc3b4c7&scoped=true&"
import script from "./RegistryRequestDetail.vue?vue&type=script&lang=js&"
export * from "./RegistryRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./RegistryRequestDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegistryRequestDetail.vue?vue&type=style&index=1&id=2bc3b4c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3b4c7",
  null
  
)

export default component.exports